import type { TranslationKey } from '@/shared/i18n';

export const ACQUISITION_SURVEY_STORAGE_KEY = 'acquisitionSurveyShown';
export const NEW_SUBSCRIPTION_WINDOW_MS = 24 * 60 * 60 * 1000;
export const ACQUISITION_SURVEY_DETAILS_MAX_LENGTH = 255;
export const SUBSCRIPTION_REFRESH_DELAYS_MS = [5000, 10_000];

export const ACQUISITION_SOURCES = [
  'google',
  'youtube',
  'instagram_facebook',
  'linkedin',
  'tiktok',
  'x',
  'chatgpt',
  'other_ai',
  'blogger',
  'friend',
  'other',
] as const;

export type AcquisitionSource = (typeof ACQUISITION_SOURCES)[number];

export const ACQUISITION_SOURCE_LABEL_KEYS: Record<AcquisitionSource, TranslationKey> = {
  blogger: 'acquisitionSurvey.source.blogger',
  chatgpt: 'acquisitionSurvey.source.chatgpt',
  friend: 'acquisitionSurvey.source.friend',
  google: 'acquisitionSurvey.source.google',
  instagram_facebook: 'acquisitionSurvey.source.instagramFacebook',
  linkedin: 'acquisitionSurvey.source.linkedin',
  other: 'acquisitionSurvey.source.other',
  other_ai: 'acquisitionSurvey.source.otherAi',
  tiktok: 'acquisitionSurvey.source.tiktok',
  x: 'acquisitionSurvey.source.x',
  youtube: 'acquisitionSurvey.source.youtube',
};

export const DATA_TEST_IDS = {
  details: 'acquisition-survey-details',
  modal: 'acquisition-survey-modal',
  option: (source: AcquisitionSource) => `acquisition-survey-option-${source}`,
  skip: 'acquisition-survey-skip',
  submit: 'acquisition-survey-submit',
} as const;
